import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../components/common/Button';

const AboutPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-center text-blue-700 mb-6">
          {t('about.title')}
        </h1>
        
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('about.whatIsCropDarpan')}
            </h2>
            <p className="text-gray-700">
              {t('about.description')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('about.howItWorks')}
            </h2>
            <p className="text-gray-700">
              {t('about.howItWorksDescription')}
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
              <li>{t('about.searchDisease')}</li>
              <li>{t('about.describeSymptoms')}</li>
            </ul>
            <p className="mt-2 text-gray-700">
              {t('about.systemInfo')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('about.developmentHistory')}
            </h2>
            <p className="text-gray-700">
              {t('about.developmentDescription')}
            </p>
            <p className="mt-2 text-gray-700">
              {t('about.databaseInfo')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('about.futureDevelopments')}
            </h2>
            <p className="text-gray-700">
              {t('about.futureDescription')}
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
              <li>{t('about.addingCrops')}</li>
              <li>{t('about.imageRecognition')}</li>
              <li>{t('about.mobileApps')}</li>
              <li>{t('about.weatherData')}</li>
            </ul>
          </section>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded"
          >
            {t('about.backToHome')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;